<template>
  <b-modal
    :visible="showDetailModal"
    @hide="$emit('close')"
    size="lg"
    title="Social Learning Detail"
    hide-footer
  >
    <div v-if="isLoadingModal" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p class="mt-2 text-muted">Loading data...</p>
    </div>
    <div v-if="selectedTNA">
      <div class="row g-0">
        <!-- Full Width - Course Info -->
        <div class="col-md-12">
          <!-- Header Section -->
          <div class="row mb-4">
            <div class="col-md-7 d-flex flex-column justify-content-between">
              <div class="d-flex flex-column">
                <!-- Status Badge -->
                <div class="mb-3">
                  <b-badge
                    :variant="getStatusVariant(selectedTNA.status)"
                    class="completion-badge"
                  >
                    {{
                      selectedTNA.status
                        ? selectedTNA.status.charAt(0).toUpperCase() +
                          selectedTNA.status.slice(1).toLowerCase()
                        : "-"
                    }}
                  </b-badge>
                </div>

                <!-- Course Title -->
                <h3 class="mb-3 font-weight-bold" style="color: #1a202c">
                  {{ selectedTNA.title || "-" }}
                </h3>

                <!-- Badge Category -->
                <b-row>
                  <b-col class="col-6">
                    <b-badge
                      class="me-1 mt-3 p-3"
                      :style="{
                        backgroundColor:
                          selectedTNA.coaching?.coaching_type_id === 'C'
                            ? '#E5FBF2'
                            : '#D7EFF6',
                        color:
                          selectedTNA.coaching?.coaching_type_id === 'C'
                            ? '#00AE65'
                            : '#2E8CA7',
                        border: 'none',
                      }"
                    >
                      {{
                        selectedTNA.coaching?.coaching_type_id === "C"
                          ? "COACHING"
                          : "MENTORING"
                      }}
                    </b-badge>
                  </b-col>
                </b-row>

                <!-- Coach Name -->
                <b-row class="mt-3">
                  <b-col class="col-6 d-flex align-items-center">
                    <i class="fe fe-user me-2"></i>
                    <span>{{ selectedTNA.coaching?.coach_name || "-" }}</span>
                  </b-col>
                </b-row>

                <!-- Methodology -->
                <b-alert
                  class="rounded-2 pb-2 mt-6"
                  show
                  style="background-color: #fafafa; border: none"
                >
                  <b-row
                    class="m-0 p-0 d-flex justify-content-between align-items-center"
                  >
                    <b-col class="m-0 p-0">
                      <h4 class="text-secondary">
                        <p class="fw-light">Methodology:</p>
                        <p>
                          <i class="fe fe-book"></i>
                          {{
                            selectedTNA?.coaching?.methodology ||
                            "No Methodology available."
                          }}
                        </p>
                      </h4>
                    </b-col>
                  </b-row>
                </b-alert>

                <b-row>
                  <b-col>
                    <strong>Related Competencies:</strong>
                  </b-col>
                  <div class="mt-2">
                    <b-badge
                      v-for="(comp, idx) in selectedTNA?.coaching
                        ?.related_competencies"
                      :key="idx"
                      class="me-2 mb-1 p-2 rounded"
                      :style="{
                        backgroundColor: 'transparent',
                        border: `1px solid black`,
                        color: 'black ',
                      }"
                    >
                      {{ comp.competency_name }}
                    </b-badge>
                  </div>
                </b-row>
              </div>
            </div>

            <!-- Right Side - Course Image -->
            <div class="col-md-5">
              <img
                :src="
                  selectedTNA && selectedTNA.cover_image_path
                    ? `${selectedTNA.cover_image_path}`
                    : `https://dummyimage.com/300x200/FAFAFA/000000&text=${
                        selectedTNA.title || 'Course'
                      }`
                "
                alt="Course Thumbnail"
                class="w-100 rounded"
                style="height: 280px; object-fit: cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "DetailTNASocial",
  emits: ["close"],
  props: {
    showDetailModal: Boolean,
    isLoadingModal: Boolean,
    selectedTNA: Object,
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    getStatusVariant(status) {
      switch (status) {
        case "approved":
          return "success";
        case "rejected":
          return "danger";
        case "pending":
          return "warning";
        default:
          return "secondary";
      }
    },
  },
};
</script>
